import graphql from '../utils/graphql';

export default {
  async getTiposPesd({ commit, getters }) {
    if (!Object.keys(getters.getTiposPesd).length) {
      try {
        const query = {
          query: ` query {
            tipos: tiposDiscapacidadesYMedidas {
              discapacidades {
                codigo
                nombre
              }
              medidas {
                codigo
                nombre
              }
            }
          }
        `,
        };
      const { tipos } = await graphql.request(query);
      commit('setTiposPesd', tipos);
      } catch (err) {
        commit('error-notification', err.message);
      }
    }
  }
};
